<template>
  <div>
    <custom-callout
      :has-toggle="true"
      :border-color="isActiveStatusItem ? 'green' : 'gray'"
      class-main="p-0"
      class="mt-2"
      :opened="isOpenedPanel"
      :controlled="true"
      @click:open="onTogglePanel"
    >
      <div class="mx-auto row">
        <div class="col-12 p-0">
          <div class="mx-auto row">
            <div class="col p-0 my-2">
              <span class="title-label">No. Semana:</span>
              <div class="regular info-label font-weight-bold">
                {{ weekItem.weekNo }}
              </div>
            </div>
            <div class="mx-auto row col-md-5 col-6 my-2 divider">
              <div class="col pt-0">
                <span class="title-label">Año Académico:</span>
                <div class="regular info-label">
                  {{ weekItem.academicYearDescription }}
                </div>
              </div>
              <div class="col pt-0">
                <span class="title-label">Comienzo de semana:</span>
                <div class="regular info-label">
                  {{ $formatDate(weekItem.startDate, $templateDate.default) }}
                </div>
              </div>
              <div class="col pt-0">
                <span class="title-label">Finalización de semana:</span>
                <div class="regular info-label">
                  {{ $formatDate(weekItem.endDate, $templateDate.default) }}
                </div>
              </div>
            </div>
            <div
              class="mx-auto row d-flex align-items-center col-md-4 col-6 my-2 divider"
            >
              <div class="col pt-0">
                <custom-toggle
                  id="sr-weeks-configutation-status-switch"
                  sync
                  class="mr-2"
                  v-model="weekItem.isRelatedServiceFlag"
                  :disabled="isToggleDisabled"
                />
                <span class="info-label">Servicios Relacionados</span>
              </div>
            </div>
            <div class="row col-12 col-md-2 p-0 pr-5 mt-md-0d-md-flex">
              <div
                class="col-12 p-0 actions dropdown edit-actions d-md-flex justify-content-end align-items-center"
              >
                <action-button
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </action-button>
                <div class="dropdown-menu dropdown-menu-right">
                  <action-button
                    type="button"
                    class="dropdown-item cursor-pointer text-left"
                    i="fas fa-edit fa-fw text-success mr-2"
                    id="editWeekBtn"
                    @click="onEditStatusFlagModeHandler(true)"
                    text="Editar"
                  />
                  <action-button
                    type="button"
                    class="dropdown-item cursor-pointer text-left"
                    i="fas fa-clock fa-fw text-success mr-2"
                    id="vieWeekHistoryBtn"
                    @click="onViewHistoryHandler"
                    text="Historial"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #edition>
        <div
          v-if="editWeekStatusFlagMode"
          class="container-fluid rounded bg-light p-3 mt-1"
        >
          <div class="mx-auto row p-0 rounded">
            <div class="col-12 p-0 m-0 d-flex align-items-center justify-content-between">
              <section-title
                bg-icon="bg-white"
                icon="fas fa-edit text-orange"
                content="Servicios Compensatorios y Facturación"
                class="p-0 m-0"
              />
              <action-button
                type="button"
                :text="allFlagsChecked ? 'Desmarcar Todos' : 'Marcar Todos'"
                :i="allFlagsChecked ? 'fas fa-times-circle' : 'fas fa-check-double'"
                :variant="allFlagsChecked ? 'outline-danger' : 'outline-success'"
                class="px-3"
                @click="checkAllFlags"
              />
            </div>
            <hr class="col-12 p-0 m-0 separator" />
            <div class="week-headers mx-auto row col-12 font-weight-bold">
              <div class="col d-flex align-items-center justify-content-center">
                Día
              </div>
              <div
                class="col d-flex align-items-center justify-content-center my-2 py-3 divider"
              >
                Admisión
              </div>
              <div
                class="col d-flex align-items-center justify-content-center my-2 py-3 divider"
              >
                Plan de Intervención
              </div>
              <div
                class="col d-flex align-items-center justify-content-center my-2 py-3 divider"
              >
                Reposición
              </div>
              <div
                class="col d-flex align-items-center justify-content-center my-2 py-3 divider"
              >
                Visita Regular
              </div>
              <div
                class="col d-flex align-items-center justify-content-center my-2 py-3 divider"
              >
                Facturación
              </div>
            </div>
            <ValidationObserver
              ref="weekSelectionForm"
              class="mx-auto row col-12 p-0"
            >
              <template v-for="(day, index) in weekItem.daysOfWeek">
                <div
                  :key="`week-record-${index}`"
                  :id="`week-record-${index}`"
                  class="week-record mx-auto row bg-white col-12 rounded px-3 mb-2"
                >
                  <div class="col pt-2 text-center">
                    <div class="regular info-label font-weight-bold">
                      {{ $formatDate(day.date, "dddd") | capitalize }}
                    </div>
                    <span class="title-label">{{
                      $formatDate(day.date, $templateDate.default)
                    }}</span>
                  </div>
                  <div
                    class="admission col d-flex align-items-center justify-content-center my-2 py-2 divider"
                  >
                    <custom-checkbox
                      :id="`checkbox-admission-${index}`"
                      v-model="day.admissionFlag"
                      class="d-flex justify-content-center"
                    />
                  </div>
                  <div
                    class="intervention-plan col d-flex align-items-center justify-content-center my-2 py-2 divider"
                  >
                    <custom-checkbox
                      :id="`checkbox-intervention-plan-${index}`"
                      v-model="day.interventionPlanFlag"
                      class="d-flex justify-content-center"
                    />
                  </div>
                  <div
                    class="reposition col d-flex align-items-center justify-content-center my-2 py-2 divider"
                  >
                    <custom-checkbox
                      :id="`checkbox-reposition-${index}`"
                      v-model="day.repositionFlag"
                      class="d-flex justify-content-center"
                    />
                  </div>
                  <div
                    class="regular-visit col d-flex align-items-center justify-content-center my-2 py-2 divider"
                  >
                    <custom-checkbox
                      :id="`checkbox-regular-visit-${index}`"
                      v-model="day.regularVisitFlag"
                      class="d-flex justify-content-center"
                    />
                  </div>
                  <div
                    class="billing-flag col d-flex align-items-center justify-content-center my-2 py-2 divider"
                  >
                    <custom-checkbox
                      :id="`checkbox-billing-flag-${index}`"
                      v-model="day.isBillingFlag"
                      class="d-flex justify-content-center"
                    />
                  </div>
                </div>
              </template>
            </ValidationObserver>
            <div class="actions col-12 mt-4 d-flex justify-content-end">
              <action-button
                class="ml-2 px-4 mb-3"
                variant="outline-danger"
                i="fas fa-times-circle"
                text="Cancelar"
                @click="onCancelEditWeek"
              />
              <action-button
                type="button"
                text="Guardar"
                i="fas fa-save"
                variant="success"
                class="ml-2 px-4 mb-3"
                @click="handleSaveWeekDetails"
              />
            </div>
          </div>
        </div>

        <div
          v-if="viewWeekHistoryMode"
          class="container-fluid rounded bg-light p-3 mt-1"
        >
          <div class="mx-auto row px-3 rounded d-flex justify-content-end">
            <section-title
              bg-icon="bg-white"
              icon="fas fa-clock text-orange history-icon d-flex justify-content-center align-items-center"
              content="Historial de Edición de Semana"
              class="col-12 p-0 my-3"
            />
            <template v-for="(weekHistory, index) in historyPagination.data">
              <div
                :key="`week-history-item-${index}`"
                class="week-history mx-auto row col-12 bg-white mt-2 py-3"
              >
                <div class="col mx-auto row">
                  <div class="d-flex justify-content-center align-items-center">
                    <i class="fa fa-arrows-retweet week-history-date-icon" />
                  </div>
                  <div class="row mx-auto">
                    <span class="col-12 info-value font-weight-bold">{{
                      $formatDate(
                        weekHistory.dateOfAction,
                        $templateDate.default
                      )
                    }}</span>
                    <span class="col-12 hour-value">
                      {{
                        $formatDate(
                          weekHistory.dateOfAction,
                          $templateDate.hour
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="col row mx-auto">
                  <span class="col-12 title-label">Semana SR:</span>
                  <span class="col-12 info-value">
                    <span
                      :class="
                        `dot ${
                          weekConfigurationStyles(
                            weekHistory.isRelatedServiceFlag
                          ).displayClass
                        } mr-2`
                      "
                    />
                    <span class="font-weight-bold">{{
                      weekConfigurationStyles(weekHistory.isRelatedServiceFlag)
                        .text
                    }}</span>
                  </span>
                </div>
                <div class="col mx-auto row">
                  <span class="col-12 title-label">Usuario:</span>
                  <span class="col-12 info-value">
                    {{ weekHistory.updatedByUser }}
                  </span>
                </div>
              </div>
            </template>
            <pagination
              v-if="historyPagination.totalItemCount > historyPagination.count"
              :data="historyPagination"
              show-text
              @pagination-go-page="goToPageHandler"
            />
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";
import CustomToggle from "@/components/common/CustomToggle.vue";
import SectionTitle from "SectionTitle";
import Pagination from "pagination";
import { CustomCheckbox, CustomIconView } from "@/components/common";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  saveWeekDetails as _saveWeekDetails,
  getWeekHistory as _getWeekHistory,
  validateIsVisitInWeekRange as _validateIsVisitInWeekRange,
  validateIsAnyVisitInDates as _validateIsAnyVisitInDates
} from "@/services/confRelatedServiceAcademicWeek.js";
import mixAlert from "@/mixin/alert.mixin";
import { cloneDeep } from "lodash";

const DEFAULT_PAGE_SIZE = 5;

export default {
  name: "ResultRow",
  components: {
    CustomCallout,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
    CustomToggle,
    SectionTitle,
    CustomCheckbox,
    Pagination,
    CustomIconView
  },
  mixins: [mixAlert],
  data: () => ({
    editWeekStatusFlagMode: false,
    weekItem: {},
    viewWeekHistoryMode: false,
    isToggleDisabled: true,
    historyPagination: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 1,
      count: DEFAULT_PAGE_SIZE,
      data: []
    }
  }),
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: () => null
    }
  },
  mounted() {
    this.weekItem = cloneDeep(this.item);
  },
  watch: {
    item() {
      this.weekItem = cloneDeep(this.item);
    }
  },
  computed: {
    isActiveStatusItem() {
      return this.weekItem?.isRelatedServiceFlag;
    },
    weekConfigurationId() {
      return this.weekItem?.id;
    },
    isOpenedPanel() {
      return this.editWeekStatusFlagMode || this.viewWeekHistoryMode;
    },
    weekConfigurationStyles() {
      return isRelatedServiceFlag => ({
        text: isRelatedServiceFlag ? "Activa" : "Inactiva",
        displayClass: isRelatedServiceFlag ? "active" : "inactive"
      });
    },
    allFlagsChecked() {
      return this.weekItem.daysOfWeek?.every(
        day =>
          day.admissionFlag &&
          day.interventionPlanFlag &&
          day.repositionFlag &&
          day.regularVisitFlag &&
          day.isBillingFlag
      );
    }
  },
  methods: {
    setIsToggleDisabled(val = true) {
      this.isToggleDisabled = val;
    },
    onTogglePanel() {
      this.onEditStatusFlagModeHandler(!this.isOpenedPanel);
    },
    onClosePanel() {
      this.setIsToggleDisabled();
      this.editWeekStatusFlagMode = false;
      this.viewWeekHistoryMode = false;
    },
    onCancelEditWeek() {
      this.onEditStatusFlagModeHandler();
      this.weekItem = cloneDeep(this.item);
    },
    onEditStatusFlagModeHandler(val = false) {
      this.onClosePanel();
      this.setIsToggleDisabled(!val);
      this.editWeekStatusFlagMode = val;
    },
    fillPayload(page) {
      const payload = {
        weekId: this.weekItem?.id,
        pageIndex: page ? page : 1,
        pageSize: DEFAULT_PAGE_SIZE
      };
      return payload;
    },
    async goToPageHandler(page) {
      const payload = this.fillPayload(page);
      await this.searchWeekHistory(payload);
    },
    async onViewHistoryHandler() {
      const pageIndex = 1;
      const payload = this.fillPayload(pageIndex);
      await this.searchWeekHistory(payload);

      this.onClosePanel();
      this.viewWeekHistoryMode = true;
    },
    async searchWeekHistory(payload) {
      try {
        const { data } = await _getWeekHistory(payload);
        this.historyPagination = { ...data };
      } catch (err) {
        this.ShowToast(
          "",
          err?.response?.data?.message ?? err?.message,
          "error"
        );
      }
    },
    async validateWeekInactivation() {
      const anyWeekFlagChangedToInactive =
        this.weekItem.isRelatedServiceFlag !== this.item.isRelatedServiceFlag &&
        !this.weekItem.isRelatedServiceFlag;

      const weekDayFlagChangedToInactiveList = this.item.daysOfWeek.filter(
        d =>
          (this.weekItem.daysOfWeek.find(w => w.id === d.id)?.repositionFlag !==
            d.repositionFlag &&
            !this.weekItem.daysOfWeek.find(w => w.id === d.id)
              ?.repositionFlag) ||
          (this.weekItem.daysOfWeek.find(w => w.id === d.id)
            ?.interventionPlanFlag !== d.interventionPlanFlag &&
            !this.weekItem.daysOfWeek.find(w => w.id === d.id)
              ?.interventionPlanFlag) ||
          (this.weekItem.daysOfWeek.find(w => w.id === d.id)
            ?.regularVisitFlag !== d.regularVisitFlag &&
            !this.weekItem.daysOfWeek.find(w => w.id === d.id)
              ?.regularVisitFlag) ||
          (this.weekItem.daysOfWeek.find(w => w.id === d.id)?.admissionFlag !==
            d.admissionFlag &&
            !this.weekItem.daysOfWeek.find(w => w.id === d.id)?.admissionFlag)
      );

      if (
        !anyWeekFlagChangedToInactive &&
        !weekDayFlagChangedToInactiveList.length
      ) {
        return true;
      }

      let dateRangeFormatted = "";

      if (anyWeekFlagChangedToInactive) {
        const params = { ...this.weekItem };
        const { data: activeVisits } = await _validateIsVisitInWeekRange(
          params
        );

        if (!activeVisits.length) return true;

        dateRangeFormatted = `${this.$options.filters.formatDate(
          this.weekItem.startDate
        )} - ${this.$options.filters.formatDate(this.weekItem.endDate)}`;
      } else {
        const dates = weekDayFlagChangedToInactiveList.map(x => x.date);
        const { data: activeVisitDates } = await _validateIsAnyVisitInDates(
          dates
        );

        if (!activeVisitDates.length) return true;

        dateRangeFormatted = activeVisitDates
          ?.map(date => this.$options.filters.formatDate(date))
          .join(", ");
      }

      const isConfirmed = await this.ShowCancelModal(
        "Días Inactivos",
        `Existen registros de visitas integrados en esta <b>${dateRangeFormatted}</b>. ¿Está seguro que deseas inactivar <b>${dateRangeFormatted}</b>?`,
        "Si",
        "No"
      );

      return isConfirmed;
    },
    checkAllFlags() {
      const newVal = !this.allFlagsChecked;
      this.weekItem.daysOfWeek.forEach(day => {
        day.admissionFlag = newVal;
        day.interventionPlanFlag = newVal;
        day.repositionFlag = newVal;
        day.regularVisitFlag = newVal;
        day.isBillingFlag = newVal;
      });
    },
    async handleSaveWeekDetails() {
      const isValid = await this.validateWeekInactivation();

      if (!isValid) return;

      const payload = { ...this.weekItem };

      try {
        await _saveWeekDetails(payload);
      } catch (err) {
        this.ShowToast(
          "",
          err?.response?.data?.message ?? err?.message,
          "error"
        );
      }
      this.$emit("update-week", this.weekItem);
      this.setIsToggleDisabled();
      this.onEditStatusFlagModeHandler();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";

$borderLightgray: #c3c3c3;

.title-label {
  font-size: 14px;
  color: map-get($colors, "secondary-6");
}
.info-label {
  color: map-get($colors, "black");
}
.hour-value {
  font-size: 14px;
  color: map-get($colors, "black");
}
.divider {
  border-left: 1px solid $borderLightgray;
}
::v-deep .tag-badge-info {
  background: transparent !important;
}
.separator {
  border-bottom: 1px solid $borderLightgray;
  border-top: 0;
  margin: 0;
}
::v-deep .input-group .option-input:checked + label span .ic-check {
  background: url("../../../../assets/img/icon-white-check-solid.svg") 50% 50%
    no-repeat;
  background-size: cover;
  border-radius: 4px;
  display: flex;
  width: 20px;
  height: 20px;
}
.dot {
  height: 8px;
  width: 8px;
  border-radius: 20px;
  display: inline-block;
}
.active {
  background-color: map-get($colors, "green-light");
}
.inactive {
  background-color: map-get($colors, "secondary-2");
}
::v-deep .history-icon {
  font-size: 20px !important;
}
.week-history-date-icon {
  background-color: map-get($colors, "secondary-2");
  color: white;
  font-size: 16px;
  font-weight: normal;
  padding: 8px 6px;
  border-radius: 50%;
}
</style>
